module.exports = __webpack_public_path__ + "img/jiuhong.bd4cbb6e.png";